export default __webpack_public_path__ + "static/media/call2action.3c8aaf8a.jpg";